import { Header5 } from '@cian/ui-kit/typography';
import { Refresh16 } from '@cian/ui-kit/icons';
import * as React from 'react';
import * as styles from './BetLeaders.css';
import { Preloader } from '@cian/preloader-component';
import { BetLeadersListContainer } from '../BetLeadersList';
import { BetLeadersErrorContainer } from '../BetLeadersError';
import { mergeStyles } from '@cian/utils';

interface IBetLeadersProps {
  isMobile: boolean;
  isLoading: boolean;
  requestTime: string;
  onReloadClick(): void;
}

export const BetLeaders = ({ isMobile, isLoading, requestTime, onReloadClick }: IBetLeadersProps) => {
  return (
    <div {...mergeStyles(styles['wrapper'], isMobile && styles['wrapper-mobile'])}>
      {isLoading && (
        <div className={styles['loader-wrapper']}>
          <Preloader size={24} preloaderStyle={styles['loader']} />
        </div>
      )}

      <div className={styles['header']} onClick={onReloadClick}>
        <Refresh16 color="gray_icons_100" />

        <span className={styles['title']}>
          <Header5 color="gray_icons_100">Данные на {requestTime}</Header5>
        </span>
      </div>

      <div className={styles['content']}>
        <BetLeadersListContainer />
      </div>

      <BetLeadersErrorContainer />
    </div>
  );
};
